import { AxiosInstance } from "axios";
import secureLocalStorage from "react-secure-storage";
import { createApiClient } from "../api/createApiClient";
import {
  AddWalletBlocklistRequest,
  WalletBlocklistActionResponse,
  WalletBlocklistAddressRequest,
  WalletBlocklistListParams,
  WalletBlocklistListResponse,
} from "../models/WalletBlocklist/WalletBlocklistModel";

class WalletBlocklistService {
  private api: AxiosInstance;
  private deactivateApi: AxiosInstance;

  constructor() {
    this.api = createApiClient();
    this.deactivateApi = createApiClient({
      handleUnauthorized: false,
    });
  }

  public async listWallets(
    params: WalletBlocklistListParams = {},
  ): Promise<WalletBlocklistListResponse> {
    const response = await this.api.get<WalletBlocklistListResponse>(
      "/adminPanel/walletBlocklist/list",
      { params },
    );
    return response.data;
  }

  public async addWallet(
    data: AddWalletBlocklistRequest,
  ): Promise<WalletBlocklistActionResponse> {
    const response = await this.api.post<WalletBlocklistActionResponse>(
      "/adminPanel/walletBlocklist/add",
      data,
    );
    return response.data;
  }

  public async activateWallet(
    data: WalletBlocklistAddressRequest,
  ): Promise<WalletBlocklistActionResponse> {
    const response = await this.api.post<WalletBlocklistActionResponse>(
      "/adminPanel/walletBlocklist/activate",
      data,
    );
    return response.data;
  }

  public async deactivateWallet(
    data: WalletBlocklistAddressRequest,
  ): Promise<WalletBlocklistActionResponse> {
    const token = secureLocalStorage.getItem("jwt");
    const response =
      await this.deactivateApi.post<WalletBlocklistActionResponse>(
        "/adminPanel/walletBlocklist/deactivate",
        data,
        {
          headers:
            typeof token === "string" && token
              ? { Authorization: `Bearer ${token}` }
              : {},
        },
      );
    return response.data;
  }
}

export const walletBlocklistService = new WalletBlocklistService();
